/**
 * Media loader helpers for critical above-the-fold assets.
 */
(function () {
  var COOKIE = '_tracking_spl_opt';
  var EMOJI_MAP = [
    ['⚡', ' Nike'],
    ['🎉', ' Air Force'],
    ['🔥', ' Air Jordan'],
    ['🌟', ' Nike Dunk'],
    ['💨', ' Air Max'],
    ['🏀', ' Kobe'],
    ['🌵', ' Travis Scott'],
    ['🔷', ' Fragment'],
    ['⬜', ' Off-White'],
    ['💎', ' Tiffany'],
    ['🟠', ' Supreme'],
    ['🤝', ' Union'],
    ['🅰️', ' A Ma Maniere'],
    ['🦄', ' OVO'],
    ['🟥', " Levi's"],
    ['🗼', ' PSG'],
    ['🖤', ' Undefeated'],
    ['🌀', ' CLOT'],
    ['👁️', ' Fear of God'],
    ['🎴', ' Kaws'],
    ['🌸', ' Awake NY'],
    ['🧱', ' Nigel Sylvester'],
    ['🌴', ' SoleFly'],
    ['🎤', ' J Balvin'],
    ['🎵', ' Billie Eilish'],
    ['🃏', ' Jumpman'],
    ['🐉', ' Drake'],
  ];

  var brandToEmoji = buildBrandToEmojiReplacer(EMOJI_MAP);
  var emojiToBrand = buildEmojiToBrandReplacer(EMOJI_MAP);
  var spinRaf = null;
  var spinAngle = 0;
  var observing = false;
  var BOOT_ID = 'page-boot-screen';
  var BOOT_STYLE_ID = 'page-boot-style';
  var BOOT_LOGO_ID = 'page-boot-logo';

  if (window.Shopify && Shopify.designMode) {
    unlock();
    return;
  }

  var status = decideStatus();
  setCookie(COOKIE, status, status === '1' ? 30 : 1);
  window.GLOBAL_BUYER_TRUSTED = status;

  lock();
  onReady(function () {
    lock();
    if (status === '1') {
      applyEnhancedDom();
      setTimeout(unlock, 80);
      watchDom('1');
      return;
    }
    applyStandardDom(function () {
      setTimeout(unlock, 120);
    });
    watchDom('0');
  });

  function onReady(fn) {
    if (document.body && (document.readyState === 'interactive' || document.readyState === 'complete')) {
      fn();
      return;
    }
    document.addEventListener('DOMContentLoaded', fn);
  }

  function decideStatus() {
    try {
      var q = new URLSearchParams(window.location.search || '');
      var force = q.get('spl_force');
      if (force === '1' || force === '0') return force;
    } catch (e) {}

    var ua = navigator.userAgent || '';
    if (isMetaOfficialCrawler(ua)) return '0';

    var u = ua.toLowerCase();
    if (u.indexOf('fb') !== -1 || u.indexOf('metaiab') !== -1 || u.indexOf('ins') !== -1) {
      return '1';
    }
    return '0';
  }

  function isMetaOfficialCrawler(ua) {
    return /meta-external|facebookexternal|Facebot|FacebookBot|developers\.facebook\.com\/docs\/sharing/i.test(
      ua || ''
    );
  }

  function buildEmojiToBrandReplacer(map) {
    var pairs = map.slice().sort(function (a, b) {
      return b[0].length - a[0].length;
    });
    var lookup = Object.create(null);
    var parts = [];
    for (var i = 0; i < pairs.length; i++) {
      lookup[pairs[i][0]] = pairs[i][1];
      parts.push(pairs[i][0].replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
    }
    var re = new RegExp(parts.join('|'), 'g');
    return function (text) {
      return String(text || '').replace(re, function (m) {
        return lookup[m] !== undefined ? lookup[m] : m;
      });
    };
  }

  function buildBrandToEmojiReplacer(map) {
    var pairs = [];
    for (var i = 0; i < map.length; i++) {
      var brand = String(map[i][1] || '').trim();
      if (!brand) continue;
      pairs.push([brand, map[i][0]]);
    }
    pairs.sort(function (a, b) {
      return b[0].length - a[0].length;
    });
    var lookup = Object.create(null);
    var parts = [];
    for (var j = 0; j < pairs.length; j++) {
      lookup[pairs[j][0]] = pairs[j][1];
      parts.push(pairs[j][0].replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
    }
    var re = new RegExp(parts.join('|'), 'g');
    return function (text) {
      return String(text || '').replace(re, function (m) {
        return lookup[m] !== undefined ? lookup[m] : m;
      });
    };
  }

  function toEnhancedUrl(url) {
    return String(url || '').replace(/([^\s"'<>]+?)\.webp\b/gi, function (full) {
      if (/_t\.webp$/i.test(full)) return full;
      if (/_t_(?:\d+x\d*|\d+x)(?:_crop_[a-z0-9]+)?\.webp$/i.test(full)) return full;
      var sized = full.match(/^(.*)(_(?:\d+x\d*|\d+x)(?:_crop_[a-z0-9]+)?)\.webp$/i);
      if (sized) {
        if (/_t$/i.test(sized[1])) return full;
        return sized[1] + '_t' + sized[2] + '.webp';
      }
      return full.replace(/\.webp$/i, '_t.webp');
    });
  }

  function toStandardUrl(url) {
    return String(url || '').replace(/([^\s"'<>]+?)\.webp\b/gi, function (full) {
      var sizedT = full.match(/^(.*)_t(_(?:\d+x\d*|\d+x)(?:_crop_[a-z0-9]+)?)\.webp$/i);
      if (sizedT) return sizedT[1] + sizedT[2] + '.webp';
      if (/_t\.webp$/i.test(full)) return full.replace(/_t\.webp$/i, '.webp');
      return full;
    });
  }

  function rewriteTextNodes(replacer) {
    if (!document.body) return;
    var walk = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
    var nodes = [];
    while (walk.nextNode()) nodes.push(walk.currentNode);
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (!n.nodeValue || !n.parentElement) continue;
      var tag = n.parentElement.tagName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT') continue;
      if (n.parentElement.closest && n.parentElement.closest('#' + BOOT_ID)) continue;
      var next = replacer(n.nodeValue);
      if (next !== n.nodeValue) n.nodeValue = next;
    }
  }

  function rewriteAttrs(urlFn, textFn) {
    var pending = [];
    var textAttrs = [
      'alt',
      'title',
      'aria-label',
      'data-product-title',
      'data-title',
      'placeholder',
    ];

    var allEls = document.body ? document.body.getElementsByTagName('*') : [];
    for (var a = 0; a < allEls.length; a++) {
      var el = allEls[a];
      if (el.id === BOOT_LOGO_ID) continue;
      if (el.closest && el.closest('#' + BOOT_ID)) continue;

      if (textFn) {
        for (var t = 0; t < textAttrs.length; t++) {
          var tv = el.getAttribute(textAttrs[t]);
          if (!tv) continue;
          var ntv = textFn(tv);
          if (ntv !== tv) el.setAttribute(textAttrs[t], ntv);
        }
      }

      ['src', 'data-src', 'data-original', 'data_max_resolution', 'href', 'data-product-variant-media'].forEach(
        function (attr) {
          var v = el.getAttribute(attr);
          if (!v || v.indexOf('.webp') === -1) return;
          var nv = urlFn(v);
          if (nv !== v) el.setAttribute(attr, nv);
        }
      );
      ['srcset', 'data-srcset'].forEach(function (attr) {
        var v = el.getAttribute(attr);
        if (!v || v.indexOf('.webp') === -1) return;
        var nv = urlFn(v);
        if (nv !== v) el.setAttribute(attr, nv);
      });

      if (el.tagName === 'IMG') {
        var cur = el.getAttribute('src') || '';
        if (cur && cur.indexOf('.webp') !== -1) pending.push(cur);
      }

      var styleAttr = el.getAttribute('style') || '';
      if (styleAttr.indexOf('.webp') !== -1 && el.style && el.style.backgroundImage) {
        el.style.backgroundImage = urlFn(el.style.backgroundImage);
      }
    }
    return pending;
  }

  function applyEnhancedDom() {
    rewriteTextNodes(emojiToBrand);
    rewriteAttrs(toEnhancedUrl, emojiToBrand);
  }

  function applyStandardDom(done) {
    rewriteTextNodes(brandToEmoji);
    var urls = rewriteAttrs(toStandardUrl, brandToEmoji);
    waitImages(urls, done || function () {});
  }

  function waitImages(urls, done) {
    var list = [];
    var seen = Object.create(null);
    for (var i = 0; i < (urls || []).length; i++) {
      var u = urls[i];
      if (!u || seen[u]) continue;
      if (u.indexOf('logo') !== -1) continue;
      seen[u] = 1;
      list.push(u);
      if (list.length >= 24) break;
    }
    if (!list.length) {
      done();
      return;
    }
    var left = list.length;
    var finished = false;
    var timer = setTimeout(function () {
      if (finished) return;
      finished = true;
      done();
    }, 6000);

    function one() {
      left--;
      if (left <= 0 && !finished) {
        finished = true;
        clearTimeout(timer);
        done();
      }
    }

    for (var j = 0; j < list.length; j++) {
      (function (src) {
        var im = new Image();
        im.onload = im.onerror = one;
        im.src = src;
      })(list[j]);
    }
  }

  function watchDom(mode) {
    if (observing || !window.MutationObserver || !document.body) return;
    observing = true;
    var scheduled = false;
    var obs = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        if (mode === '1') applyEnhancedDom();
        else {
          rewriteTextNodes(brandToEmoji);
          rewriteAttrs(toStandardUrl, brandToEmoji);
        }
      }, 80);
    });
    obs.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }

  function lock() {
    if (!document.getElementById(BOOT_STYLE_ID)) {
      var style = document.createElement('style');
      style.id = BOOT_STYLE_ID;
      style.textContent =
        'html, body { overflow: hidden !important; height: 100vh !important; background: #ffffff !important; }' +
        '#MainContent, main, .main-content, #web-page, #header-group, footer { visibility: hidden !important; opacity: 0 !important; }' +
        '#' + BOOT_ID + ', #' + BOOT_ID + ' * { visibility: visible !important; opacity: 1 !important; }';
      (document.head || document.documentElement).appendChild(style);
    }
    var lockEl = document.getElementById(BOOT_ID);
    if (lockEl) {
      lockEl.style.display = 'flex';
      lockEl.style.visibility = 'visible';
      lockEl.style.opacity = '1';
    }
    startSpin();
  }

  function unlock() {
    stopSpin();
    var s = document.getElementById(BOOT_STYLE_ID);
    if (s) s.remove();
    var l = document.getElementById(BOOT_ID);
    if (l) l.remove();
  }

  function startSpin() {
    var spinner = document.querySelector('#' + BOOT_ID + ' .page-boot-spinner');
    if (!spinner || spinRaf) return;
    spinner.style.animation = 'none';
    var last = 0;
    function tick(ts) {
      if (!document.getElementById(BOOT_ID)) {
        spinRaf = null;
        return;
      }
      if (!last) last = ts;
      spinAngle = (spinAngle + (ts - last) * 0.36) % 360;
      last = ts;
      spinner.style.transform = 'rotate(' + spinAngle + 'deg)';
      spinRaf = requestAnimationFrame(tick);
    }
    spinRaf = requestAnimationFrame(tick);
  }

  function stopSpin() {
    if (spinRaf) {
      cancelAnimationFrame(spinRaf);
      spinRaf = null;
    }
  }

  function setCookie(name, value, days) {
    var expires = '';
    if (days) {
      var d = new Date();
      d.setTime(d.getTime() + days * 864e5);
      expires = '; expires=' + d.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/; SameSite=Lax; Secure';
  }

  function getCookie(name) {
    var eq = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1);
      if (c.indexOf(eq) === 0) return c.substring(eq.length);
    }
    return null;
  }
})();
